"use strict";

export default {

	/**
	 * cache
	 * @type {Object}
	 */
	cacheContent: {},

	/**
     * Set cache key / value pair.
     * @param {String} key
     * @param {Object|String|Number} value
     * @return
     */
	set(key, value)
	{
		this.cacheContent[key] = value; 
	},

	/**
     * Get value from cache storage
     * @param {String} key
     * @return {null|Object|String|Number}
     */
	get(key)
	{
		if (this.cacheContent.hasOwnProperty(key)) {
			return this.cacheContent[key];
		}

		return null;
	},

	/**
     * Remove key / value pair from cache storage
     * @param {String} key
     * @return
     */
	remove(key)
	{
		if (this.cacheContent.hasOwnProperty(key)) {
			delete this.cacheContent[key];
		}
	},

	flush()
	{
		this.cacheContent = {};
	}

}
